import React, { useState } from 'react';
import styled from 'styled-components';

const DropdownWrapper = styled.div`
  background: #ffffff;
  border-bottom: 1px solid #e2e8f0;
  transition: all 0.3s ease;
`;

const DropdownHeader = styled.div`
  padding: 10px 20px;
  background: linear-gradient(135deg, #3b74b8 0%, #275386 55%, #1b3c66 100%);
  color: white;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.2s ease;

  &:hover {
    background: linear-gradient(135deg, #2f66a6 0%, #1f4470 55%, #163353 100%);
  }
`;

const DropdownTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const DropdownContent = styled.div`
  max-height: ${props => props.isOpen ? '250px' : '0'};
  overflow: hidden;
  transition: max-height 0.3s ease;
  padding: ${props => props.isOpen ? '16px 20px 8px 20px' : '0 20px'};
`;

const ButtonsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 8px;
  max-width: 100%;
`;

const OptionButton = styled.button`
  background: white;
  border: 2px solid #275386;
  border-radius: 20px;
  padding: 8px 16px;
  text-align: center;
  font-size: 13px;
  font-weight: 500;
  color: #275386;
  cursor: pointer;
  transition: all 0.2s ease;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    background: #275386;
    color: white;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
  }
  
  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 6px rgba(59, 130, 246, 0.3);
  }
`;

const ArrowContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 8px 0;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: #f8fafc;
  }
`;

const DropdownArrow = styled.div`
  transition: transform 0.3s ease;
  transform: ${props => props.isOpen ? 'rotate(180deg)' : 'rotate(0deg)'};
  font-size: 16px;
  color: #275386;
  padding: 4px 8px;
  border-radius: 50%;
  
  &:hover {
    background: #e2e8f0;
  }
`;

const DropdownOptions = ({ onOptionSelect, isOpen = true }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(isOpen);

  // 8 simple button options
  const options = [
    'Active Case',
    'Completed Cases', 
    'Request Callback',
    'Technical Issue',
    'Order Status',
    'Platform Issue',
    'Connect Radiologist',
    'Feedback'
  ];

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleOptionClick = (option) => {
    onOptionSelect(option);
  };

  return (
    <DropdownWrapper>
      <DropdownHeader onClick={toggleDropdown}>
        <DropdownTitle>
          <span>💬</span>
          Quick Options
        </DropdownTitle>
      </DropdownHeader>
      
      <DropdownContent isOpen={isDropdownOpen}>
        <ButtonsContainer>
          {options.map((option, index) => (
            <OptionButton
              key={index}
              onClick={() => handleOptionClick(option)}
            >
              {option}
            </OptionButton>
          ))}
        </ButtonsContainer>
      </DropdownContent>

      <ArrowContainer onClick={toggleDropdown}>
        <DropdownArrow isOpen={isDropdownOpen}>
          ▼
        </DropdownArrow>
      </ArrowContainer>
    </DropdownWrapper>
  );
};

export default DropdownOptions;